import axiosInstance from "@/utils/AxiosInstance";
import {RequestOfficePage} from "@/services/offices/entities/RequestOfficePage";
import {RequestCreateOffice} from "@/services/offices/entities/RequestCreateOffice";

const BASE_API = '/offices';

const getAvailableOffices = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/available`);
}

const getOfficePage = async (body: RequestOfficePage): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/page`, body);
}

const createOffice = async (body: RequestCreateOffice): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/`, body);
}

const updateOffice = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/`, body);
}

export default {
    getAvailableOffices,
    getOfficePage,
    createOffice,
    updateOffice,
}